import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Modal } from '../common/Modal';

export interface CompleteModalProps {
	isOpen: boolean;
	items: CompleteModalItem[];
	headerTitleId: string;
	descriptionTitleId: string;
	okButtonTitleId: string | null;
	nextButtonTitleId: string | null;
	nextButtonVisible: boolean;
	onOk: () => void;
	onNext?: () => void;
}

export interface CompleteModalItem {
	id: string;
}

export interface CompleteModalState {}

export class CompleteModal extends React.Component<CompleteModalProps, CompleteModalState> {
	constructor(props: CompleteModalProps) {
		super(props);

		this.state = {};
	}

	render() {
		const headerTitleId = this.props.headerTitleId;
		const descriptionTitleId = this.props.descriptionTitleId;
		const okButtonTitleId = this.props.okButtonTitleId || 'button.ok';
		const nextButtonTitleId = this.props.nextButtonTitleId || 'button.addLater';

		return (
			<Modal
				isOpen={this.props.isOpen}
				closeOnBackdropClick={true}
				onClose={this.props.onOk}
				header={
					<h2>
						<FormattedMessage id={headerTitleId} />
					</h2>
				}
			>
				<>
					<UlCenteredContainer>
						<Paragraph>
							<FormattedMessage id={descriptionTitleId} />
						</Paragraph>
						<Ul>
							{this.props.items
								? this.props.items.map((it, index) => (
										<Li>
											<FormattedMessage id={it.id} key={index} />
										</Li>
									))
								: null}
						</Ul>
					</UlCenteredContainer>
					<ButtonContainer>
						<button onClick={this.props.onOk}>
							<FormattedMessage id={okButtonTitleId} />
						</button>
						{this.props.nextButtonVisible ? (
							<button className="secondary" onClick={this.props.onNext}>
								<FormattedMessage id={nextButtonTitleId} />
							</button>
						) : null}
					</ButtonContainer>
				</>
			</Modal>
		);
	}
}

const Li = styled.li`
	list-style-position: inside;
	margin-bottom: 0.5rem;
`;

const UlCenteredContainer = styled.div`
	display: flex;
	justify-content: left;
	flex-direction: column;
	text-align: left;
	margin-bottom: 2rem;
`;

const Ul = styled.ul`
	/* margin: 1rem 0 3rem 0; */
	margin: auto;
`;

const Paragraph = styled.p`
	hyphens: auto;
	margin: 1rem auto;
`;

const ButtonContainer = styled.p`
	display: grid;
	justify-content: center;
	grid-row-gap: 1rem;
`;
